module.exports = __webpack_public_path__ + "static/img/helongfei8.513eead.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/employeeStories/helongfei8.png
// module id = 8rcq
// module chunks = 1